import CreateNewFolderOutlined from "@mui/icons-material/CreateNewFolderOutlined";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import DriveFileMoveOutlined from "@mui/icons-material/DriveFileMoveOutlined";
import DriveFileRenameOutline from "@mui/icons-material/DriveFileRenameOutline";
import LinkOutlined from "@mui/icons-material/LinkOutlined";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

type CustomTreeItemMenuProps = {
  menuOpen: boolean;
  menuAnchor: HTMLElement | null;
  onMenuOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMenuClose: () => void;
  onRename: () => void;
};

export const CustomTreeItemMenu = ({
  menuOpen,
  menuAnchor,
  onMenuOpen,
  onMenuClose,
  onRename,
}: CustomTreeItemMenuProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton
        size="small"
        className="folder-menu-button"
        onClick={onMenuOpen}
        aria-label={t("Folder actions")}
        data-analytics-id="content-library-folder-menu"
      >
        <MoreHoriz fontSize="small" />
      </IconButton>
      <Menu
        open={menuOpen}
        anchorEl={menuAnchor}
        onClose={onMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { minWidth: 200 } } }}
      >
        <MenuItem onClick={onRename}>
          <ListItemIcon>
            <DriveFileRenameOutline fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("Rename")}</ListItemText>
        </MenuItem>
        <MenuItem>
          <ListItemIcon>
            <CreateNewFolderOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("Create sub-folder")}</ListItemText>
        </MenuItem>
        <MenuItem>
          <ListItemIcon>
            <LinkOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("Get sharing link")}</ListItemText>
        </MenuItem>
        <MenuItem>
          <ListItemIcon>
            <DriveFileMoveOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("Move")}</ListItemText>
        </MenuItem>
        <MenuItem>
          <ListItemIcon>
            <DeleteOutline fontSize="small" sx={{ color: "error.main" }} />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>{t("Delete")}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
